import uploadsaboutsidebyside01imageamberPinkJpg from "$lib/data/generated/uploads/about/SideBySide 01/image/amber-pink.jpg";

export const uploads = {
  "uploads/about/SideBySide 01/image/amber-pink.jpg": uploadsaboutsidebyside01imageamberPinkJpg
};